import {
  createFormField,
  FormFieldBlueprint,
} from '@backstage/plugin-scaffolder-react/alpha';
import { AsyncProductAndServiceSelect } from './function';
import { asyncProductAndServiceSelectValidation } from './validation';

export const AsyncProductAndServiceSelectFormField = FormFieldBlueprint.make({
  name: 'async-product-and-service-select',
  params: {
    field: async () =>
      createFormField({
        name: 'AsyncProductAndServiceSelect',
        component: AsyncProductAndServiceSelect,
        validation: asyncProductAndServiceSelectValidation,
      }),
  },
});
